import ActionBar from '@com/Layout/ActionBar';
import { Button } from '@com/_atoms/NewButton';

type ReserveActionBarProps = {
  onReserve?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
};

const ReserveActionBar = ({
  onReserve,
  isLoading = false,
  isDisabled,
}: ReserveActionBarProps) => {
  return (
    <ActionBar type="singleAction" hasDivider>
      <Button
        className="w-full bg-surface-inverse-primary"
        onClick={onReserve}
        isLoading={isLoading}
        disabled={isDisabled}
        dataTestId="healthcare-confirm-booking"
      >
        رزرو نوبت
      </Button>
    </ActionBar>
  );
};

export default ReserveActionBar;
